export default __webpack_public_path__ + "static/media/IMG_0413-2.d66b3f3d.jpg";